import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { getQueryString, objectKeysCamelToSnakeCase } from 'core/utils';
import { ICustomerExternalNumber } from 'customer/types';

export const getExternalCustomerNumbers = async (requestPayload, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/customer/external-customer-number/list?${getQueryString(
      objectKeysCamelToSnakeCase(requestPayload)
    )}`,
    signal
  );

  return mapRecordsFromServer<ICustomerExternalNumber>(data.external_customer_numbers);
};
